interface IconProps {
  name: string;
  className?: string;
}

export function Icon({ name, className }: IconProps) {
  return <svg className={className} aria-hidden="true"><use href={`/assets/icons/caigen-icons.svg#${name}`} /></svg>;
}
